import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { RouterModule, Routes } from '@angular/router';
import { FormsModule } from '@angular/forms';
import { ReactiveFormsModule } from '@angular/forms';
import { CompaniesRoutingModule } from './companies-routing.module';
import { CompaniesComponent } from './companies.component';
import { CreateGroupComponent } from './create-group-modal/create-group.component';

import { InputMaskModule } from 'ng2-inputmask';
import { SharedModule } from '../../shared/shared.module';

@NgModule({
    declarations: [
        CompaniesComponent,
        CreateGroupComponent
    ],

    imports: [
        CommonModule,
        CompaniesRoutingModule,
        FormsModule,
        ReactiveFormsModule,
        InputMaskModule,
        SharedModule
    ],

    exports: [

    ],
    entryComponents: [
        CreateGroupComponent ],
})

export class CompaniesModule {
}



// WEBPACK FOOTER //
// C:/www/onetouchSuperAdmin/src/app/pages/companies/companies.module.ts